const GoogleCallback = () => (
  <div className='flex items-center justify-center h-full text-lg font-semibold'>
    Processing Google login...
  </div>
);

export default GoogleCallback;
